const SECTION_SELECTOR = ".section--platform-stack";
const GRID_SELECTOR = ".platform-stack__grid";
const TAG_SELECTOR = ".platform-stack__tag";
const DESKTOP_MIN_WIDTH = 1199;
const TAG_DURATION = 0.5;
const TAG_STAGGER = 0.08;
const TRIGGER_START = "top 85%";

class PlatformStackReveal {
  constructor() {
    this.section = document.querySelector(SECTION_SELECTOR);
    this.grid = this.section?.querySelector(GRID_SELECTOR);
    this.tags = this.grid ? [...this.grid.querySelectorAll(TAG_SELECTOR)] : [];

    if (
      !this.section ||
      this.tags.length === 0 ||
      typeof gsap === "undefined"
    ) {
      return;
    }

    if (window.innerWidth < DESKTOP_MIN_WIDTH) {
      this.tags.forEach((tag) => tag.classList.add("is-revealed"));
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    this.init();
  }

  isPastTrigger() {
    const target = this.grid || this.section;
    const rect = target.getBoundingClientRect();
    const triggerPercent =
      parseFloat(TRIGGER_START.split(" ")[1]) / 100 || 0.85;

    return rect.top < window.innerHeight * triggerPercent;
  }

  play() {
    gsap.to(this.tags, {
      opacity: 1,
      y: 0,
      duration: TAG_DURATION,
      ease: "power2.out",
      stagger: TAG_STAGGER,
      force3D: true,
      onComplete: () => {
        this.tags.forEach((tag) => {
          tag.classList.add("is-revealed");
          tag.style.willChange = "auto";
        });
      },
    });
  }

  init() {
    gsap.set(this.tags, {
      opacity: 0,
      y: 24,
      visibility: "visible",
      force3D: true,
      willChange: "transform, opacity",
    });

    if (this.isPastTrigger()) {
      this.play();
      return;
    }

    ScrollTrigger.create({
      trigger: this.grid || this.section,
      start: TRIGGER_START,
      once: true,
      onEnter: () => this.play(),
    });
  }
}

if (document.querySelector(SECTION_SELECTOR)) {
  new PlatformStackReveal();
}

export default PlatformStackReveal;
